import connectHitsPerPage from "instantsearch.js/es/connectors/hits-per-page/connectHitsPerPage.js";
import { useConnector } from "../hooks/useConnector.js";
export function useHitsPerPage(props, additionalWidgetProperties) {
  return useConnector(connectHitsPerPage, props, additionalWidgetProperties);
}